import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import AuthService from '../services/auth.service'

const Logout = (props) => {
  const history = useNavigate()
  useEffect(() => {
    AuthService.logout()
    props.setCurrentUser(undefined)
    history('/Login')
  })

  return <></>
}

export default Logout
